import { useFormContext } from 'react-hook-form'

import { ButtonGroup, TextArea } from '@/components/Forms'
import { ButtonGroupOption, ButtonProps } from '@/ui/Button'
import { UsedTranzauraValue } from '@/types/mechanicalInformation'
import { MECHANICAL_INFORMATION_FORM_FIELDS } from '../../constant'

import styles from '../MechanicalInformationModal.module.scss'

const BUTTON_PROPS: ButtonProps = {
    variant: 'outline',
}

const options: ButtonGroupOption[] = [
    {
        ...BUTTON_PROPS,
        value: UsedTranzauraValue.Yes,
        label: 'Yes',
    },
    {
        ...BUTTON_PROPS,
        value: UsedTranzauraValue.No,
        label: 'No',
    },
    {
        ...BUTTON_PROPS,
        value: UsedTranzauraValue.NoDevice,
        label: 'No device',
    },
]

export const IssueDetails = () => {
    const { register } = useFormContext()

    return (
        <div className={styles.formItemsContainer}>
            <span className={styles.textBold}>Issue details</span>
            <ButtonGroup
                name={MECHANICAL_INFORMATION_FORM_FIELDS.usedTranzaura}
                label="Has the driver used Tranzaura?"
                options={options}
                className={styles.buttonGroup}
            />
            <TextArea
                label="Time Engineering was contacted"
                className={styles.info}
                {...register(MECHANICAL_INFORMATION_FORM_FIELDS.contactTimeDetails)}
            />
            <TextArea
                label="Engineering statement"
                className={styles.info}
                {...register(MECHANICAL_INFORMATION_FORM_FIELDS.engineeringStatement)}
            />
        </div>
    )
}
